<ui-button
	*ngIf="date_()"
	preset="ICON_DEFAULT"
	size="sm"
	icon="history"
	[label]="date_() | date: 'MMM d, yyyy'"
	(click)="gotoPackageHistory(); $event.stopPropagation()"
	[attr.data-intercom-target]="dataIntercomTarget_()"
/>
